import { extendTheme } from "@chakra-ui/react";
import { bg } from "date-fns/locale";

const theme = extendTheme({
    colors: {
        myColor: {
            white: "#EEEEEE",
            blue: "#171f2b",
            green: "#00B2AC",
            gradient: "linear-gradient(127deg,rgba(0, 178, 172, 1) 0%, rgba(40, 153, 184, 1) 100%)",
            black: "#1A1A1D",
            red: "#c3073f",
            crimson: "#950740",
            bloody: "#6F2232",
            gray: "#4e4e50",
            darkGray: "#282828",
            brightBlue: "#3500D3",
            commonBlue: "#240090",
            darkBlue: "#190061",
            text: "#EEEEEE",

            bgBlock: "rgb(24, 24, 24)",

            blueGradient: "linear-gradient(135deg,rgba(220, 245, 255, 1) 0%, rgba(70, 103, 199, 1) 100%)"
        }
    },
    components: {
        Text: {
            baseStyle: {
                fontSize: "14px"
            },
        },
    },
});

export default theme;
